import React from 'react';

// components
import {
  TextInput,
  Checkbox,
  Select,
  YesNo,
} from '../components/inputs';
import { FormRow } from '../components/layout';

function Email() {
  return (
    <div>
      <FormRow>
        <Select
          name="prefcontactmethod"
        />
      </FormRow>
      <FormRow>
        <TextInput
          label="Email address"
          name="email"
        />
      </FormRow>
      <FormRow>
        <Checkbox
          label="OK to email: is it ok for us to contact you by email?"
          name="okemail"
        />
      </FormRow>
      <FormRow>
        <YesNo name="paperless_optin" />
      </FormRow>
      <FormRow
        showIfFieldsExist={[
          'eobbymail',
          'billbymail',
          'plandocsbymail',
          'materialsbymail',
        ]}
      >
        <Checkbox name="eobbymail" />
        <Checkbox name="billbymail" />
        <Checkbox name="plandocsbymail" />
        <Checkbox name="materialsbymail" />
      </FormRow>
    </div>
  );
}

export default Email;
